<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-row>
            <v-col cols="12" lg="8" offset-lg="2">
                <div class="text-h5 mb-3">Negocio {{ title }}</div>
                <v-btn
                    color="error"
                    text
                    href="/admin/stores"
                >Atrás</v-btn>
                <v-card class="mb-5">
                    <v-card-text>
                        <v-form @submit.prevent="formEdit" ref="refedit" lazy-validation>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <h4>Datos de cuenta</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <!-- name -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Nombre completo"
                                        type="text"
                                        name="name"
                                        outlined
                                        dense
                                        v-model="data.name"
                                        :rules="[rules.required]"
                                        :error="errors['name'] ? true :false"
                                        :error-messages="errors['name'] ? errors['name'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <!-- end name -->
                                <!-- email -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Correo electrónico"
                                        type="email"
                                        name="email"
                                        outlined
                                        dense
                                        v-model="data.email"
                                        :rules="[rules.required, rules.email]"
                                        :error="errors['email'] ? true :false"
                                        :error-messages="errors['email'] ? errors['email'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <!-- end email -->
                                <!-- phone -->
                                <v-col cols="12" md="6" class="px-2">
                                    <vue-tel-input-vuetify
                                        label="Tel/cel *"
                                        outlined
                                        dense
                                        :onlyCountries="['bo', 'us', 'es', 'ar', 'cl', 'co', 'ec', 'mx', 'pe', 've', 'br']"
                                        :default-country="defaultCountry"
                                        :rules="[rules.required]"
                                        :value="data.tmpPhone"
                                        @input="onInput"
                                        :error="errors['phone'] ? true :false"
                                        :error-messages="errors['phone'] ? errors['phone'][0] : ''"
                                    ></vue-tel-input-vuetify>
                                </v-col>
                                <!-- end phone -->
                                <!-- country -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-select
                                        :items="itemsCountry"
                                        item-value="val"
                                        item-text="text"
                                        label="País *"
                                        outlined
                                        dense
                                        v-model="data.country"
                                        :rules="[rules.required]"
                                        :error="errors['country'] ? true :false"
                                        :error-messages="errors['country'] ? errors['country'][0] : ''"
                                    ></v-select>
                                </v-col>
                                <!-- end country -->
                                <!-- address -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Dirección"
                                        type="text"
                                        name="address"
                                        outlined
                                        dense
                                        v-model="data.address"
                                        :rules="[rules.required]"
                                        :error="errors['address'] ? true :false"
                                        :error-messages="errors['address'] ? errors['address'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <!-- end address -->
                                <!-- password -->
                                <v-col cols="12" md="6" class="px-2">
                                    <div class="input-container d-flex">
                                        <v-text-field
                                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show1 ? 'text' : 'password'"
                                            label="Contraseña *"
                                            hint="Mínimo 8 caracteres"
                                            counter
                                            dense
                                            outlined
                                            v-model="data.password"
                                            :error="errors.password ?true :false"
                                            :error-messages="errors['password'] ? errors['password'][0] : ''"
                                            @click:append="show1 = !show1"
                                        ></v-text-field>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    class="ml-2"
                                                    fab
                                                    dark
                                                    small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="data.password = genRandom()"
                                                >
                                                    <v-icon dark>
                                                        mdi-reload
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Generar</span>
                                        </v-tooltip>
                                    </div>
                                </v-col>
                                <!-- end password -->

                                <v-col cols="12">
                                    <h4>Datos del negocio</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <!-- name -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Nombre del negocio"
                                        type="text"
                                        name="name_store"
                                        outlined
                                        dense
                                        v-model="data.nameStore"
                                        :rules="[rules.required]"
                                        :error="errors['name_store'] ? true :false"
                                        :error-messages="errors['name_store'] ? errors['name_store'][0] : ''"
                                        @blur="generateSlug"
                                    ></v-text-field>
                                </v-col>
                                <!-- end name -->
                                <!-- slug -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Slug"
                                        type="text"
                                        name="slug"
                                        outlined
                                        dense
                                        v-model="data.slug"
                                        :rules="[rules.required]"
                                        :error="errors['slug'] ? true :false"
                                        :error-messages="errors['slug'] ? errors['slug'][0] : ''"
                                    >
                                        <template v-slot:prepend>
                                            <div class="text--disabled pt-1" style="width:170px">
                                                {{ tmpSlug }}
                                            </div>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <!-- end slug -->
                                 <!-- type -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-select
                                        :items="itemsTypeStores"
                                        item-value="id"
                                        item-text="name"
                                        label="Tipo de tienda *"
                                        outlined
                                        dense
                                        v-model="data.typeStoreId"
                                        :rules="[rules.required]"
                                        :error="errors['type_store_id'] ? true :false"
                                        :error-messages="errors['type_store_id'] ? errors['type_store_id'][0] : ''"
                                    ></v-select>
                                </v-col>
                                <!-- end type -->

                                <v-col cols="12">
                                    <h4>Puntos de venta</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Cantidad de puntos de venta"
                                        type="number"
                                        outlined
                                        dense
                                        v-model="data.pointSale"
                                        :error="errors['point_sale'] ? true :false"
                                        :error-messages="errors['point_sale'] ? errors['point_sale'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <!-- end points -->

                                <v-col cols="12">
                                    <h4>Preventista</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Cantidad de preventista"
                                        type="number"
                                        outlined
                                        dense
                                        v-model="data.preventist"
                                        :error="errors['preventist'] ? true :false"
                                        :error-messages="errors['preventist'] ? errors['preventist'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <!-- end points -->

                                <v-col cols="12">
                                    <h4>Tamaño de impresión del recibo</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-radio-group
                                        v-model="data.sizePrint"
                                        row
                                        class="mt-0"
                                    >
                                        <v-radio
                                            label="Papel carta"
                                            value="md"
                                        ></v-radio>
                                        <v-radio
                                            label="Papel térmico"
                                            value="sm"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>

                                <!-- retorno inversion -->
                                <v-col cols="12" class="px-2">
                                    <h4>Datos de inversión</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Inversión meses"
                                        type="number"
                                        outlined
                                        dense
                                        v-model="data.investmentMounths"
                                        :error="errors['investment_mounths'] ? true :false"
                                        :error-messages="errors['investment_mounths'] ? errors['investment_mounths'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Inversión Bs."
                                        type="number"
                                        outlined
                                        dense
                                        v-model="data.investmentAmount"
                                        :error="errors['investment_amount'] ? true :false"
                                        :error-messages="errors['investment_amount'] ? errors['investment_amount'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="rentabilidad en %"
                                        type="number"
                                        outlined
                                        dense
                                        v-model="data.profitabilityIn"
                                        :error="errors['profitability_in'] ? true :false"
                                        :error-messages="errors['profitability_in'] ? errors['profitability_in'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-menu
                                        v-model="menuD"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="data.investmentInit"
                                                label="Fecha inicial"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                outlined
                                                dense
                                                color="orange"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="data.investmentInit"
                                            @input="menuD = false"
                                            locale="es"
                                            color="primary"
                                            class="ma-0"
                                            type="month"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <!-- END inversion -->

                                <v-col cols="12" class="px-2">
                                    <h4>Sucursales</h4>
                                    <v-divider class="mb-4"></v-divider>
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        Nombre
                                                    </th>
                                                    <th class="text-left">
                                                        Slug
                                                    </th>
                                                    <th class="text-left">
                                                        Estado
                                                    </th>
                                                    <th class="text-right">
                                                        Acciones
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(branch, j) in data.branches" :key="j">
                                                    <td>
                                                        {{ branch.name_store }}
                                                        <v-chip x-small color="success" v-if="branch.type_store == 'main'">Principal</v-chip>
                                                        <v-chip x-small v-else>Sucursal</v-chip>
                                                    </td>
                                                    <td>{{ branch.slug }}</td>
                                                    <td>
                                                        <v-switch
                                                            color="primary"
                                                            :true-value="1"
                                                            :false-value="0"
                                                            v-model="branch.state"
                                                            :label="branch.state ? 'Activo' : 'Inactivo'"
                                                            @change="changeStateBranch($event, branch.id)"
                                                        ></v-switch>
                                                    </td>
                                                    <td class="text-right">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    icon
                                                                    @click="tmpNameStore = branch.name_store, tmpSlugStore = branch.slug, tmpIdStore = branch.id, typeEdit = 'old', dialogEditName = !dialogEditName"
                                                                >
                                                                    <v-icon color="grey">
                                                                        mdi-pencil
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Editar nombre</span>
                                                        </v-tooltip>
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    icon
                                                                    @click="deleteStore(branch.id)"
                                                                >
                                                                    <v-icon color="grey">
                                                                        mdi-delete
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Eliminar</span>
                                                        </v-tooltip>
                                                    </td>
                                                </tr>
                                                <tr v-for="(add, m) in newBranches" :key="m+'add'">
                                                    <td>
                                                        {{ add.name_store }}
                                                    </td>
                                                    <td>
                                                        {{ add.slug }}
                                                    </td>
                                                    <td>
                                                        <v-switch
                                                            color="primary"
                                                            :true-value="1"
                                                            :false-value="0"
                                                            v-model="add.state"
                                                            :label="add.state ? 'Activo' : 'Inactivo'"
                                                        ></v-switch>
                                                    </td>
                                                    <td class="text-right">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    icon
                                                                    @click="tmpNameStore = add.name_store, tmpSlugStore = add.slug, typeEdit = 'new', tmpIndexNew = m, dialogEditName = !dialogEditName"
                                                                >
                                                                    <v-icon color="grey">
                                                                        mdi-pencil
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Editar</span>
                                                        </v-tooltip>
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    icon
                                                                    @click="newBranches.splice(m, 1)"
                                                                >
                                                                    <v-icon color="grey">
                                                                        mdi-delete
                                                                    </v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Eliminar</span>
                                                        </v-tooltip>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colspan="4" class="text-right py-2">
                                                        <v-btn
                                                            class="text-capitalize"
                                                            dark
                                                            small
                                                            @click="()=>{newBranches.push({name_store: `${data.nameStore} - Sucursal${(data.branches.length)+(newBranches.length)}`, slug: `${data.slug}-sucursal${(data.branches.length)+(newBranches.length)}`, state: 1, branch: ((data.branches.length)+(newBranches.length))})}"
                                                        >
                                                            Agregar
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </template>
                                    </v-simple-table>
                                    <p class="mb-3">&nbsp;</p>
                                </v-col>

                                <v-col cols="12" class="px-2">
                                    <h4>Otros</h4>
                                    <v-divider class="mb-4"></v-divider>
                                    <v-checkbox
                                        v-model="data.inventory"
                                        label="Inventario"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.physicalStore"
                                        label="Tienda fisica"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.preventistChange"
                                        label="Preventista cambio de precios"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.restaurant"
                                        label="Restaurante físico"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.fidelityPoints"
                                        label="Puntos de fidelidad"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.isDomain"
                                        label="Dominio propio"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <p class="mb-3">&nbsp;</p>
                                </v-col>
                                <!-- end points -->

                                <!-- status -->
                                <v-col cols="12" md="12" class="px-2">
                                    <v-switch
                                        v-model="data.state"
                                        inset
                                        :label="`Estado: ${(data.state)?'activo':'inactivo'}`"
                                    ></v-switch>
                                </v-col>
                                <!-- end status -->

                                <v-col cols="12" sm="12" class="text-center">
                                    <v-btn
                                        type="submit"
                                        dark
                                        color="primary"
                                        :loading="loading"
                                    >
                                        Actualizar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- edit name -->
        <v-dialog
            v-model="dialogEditName"
            width="500"
        >
            <v-card>
                <v-card-title>
                    Editar nombre
                </v-card-title>

                <v-card-text>
                    <v-text-field
                        label="Nombre del negocio"
                        type="text"
                        name="name_store"
                        outlined
                        dense
                        v-model="tmpNameStore"
                        :rules="[rules.required]"
                        :error="errors['name_store'] ? true :false"
                        :error-messages="errors['name_store'] ? errors['name_store'][0] : ''"
                        @blur="generateSlug($event, 'edit')"
                    ></v-text-field>
                    {{ tmpSlug }}{{tmpSlugStore}}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        outlined
                        @click="dialogEditName = false"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="updateNameStore"
                        v-if="typeEdit == 'old'"
                    >
                        Guardar
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="updateNewNameStore"
                        v-if="typeEdit == 'new'"
                    >
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';
export default {
    components: {
        VueTelInputVuetify,
    },
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Negocios',
                    disabled: false,
                    href: '/admin/stores',
                },
                {
                    text: 'Editar',
                    disabled: true,
                    href: '',
                }
            ],
            show1: true,
            itemsCountry: [
                {val: 'bo', text: 'Bolivia'},
                {val: 'us', text: 'Estados Unidos'},
                {val: 'es', text: 'España'},
                {val: 'ar', text: 'Argentina'},
                {val: 'cl', text: 'Chile'},
                {val: 'co', text: 'Colombia'},
                {val: 'ec', text: 'Ecuador'},
                {val: 'mx', text: 'México'},
                {val: 'pe', text: 'Perú'},
                {val: 've', text: 'Venezuela'},
                {val: 'br', text: 'Brasil'},
            ],
            itemsTypeStores: [],
            defaultCountry: 'bo',
            data: {
                id: '',
                name: '',
                email: '',
                tmpPhone: '',
                phoneCode: '',
                phoneIso: '',
                phoneValid: false,
                phone: '',
                address: '',
                password: '',
                nameStore: '',
                state: true,
                slug: '',
                typeStoreId: '',
                pointSale: 0,
                preventist: 0,
                sizePrint: 'md',
                country: '',
                inventory: false,
                physicalStore: false,
                investmentMounths: '',
                investmentAmount: '',
                profitabilityIn: '',
                investmentInit: '',
                preventistChange: false,
                restaurant: false,
                fidelityPoints: false,
                isDomain: false,
                branches: []
            },
            menuD: false,
            title: '',
            tmpSlug: 'http://'+window.location.hostname+'/',
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
            },
            errors: {},
            // nuevas suscursales
            newBranches: [],
            dialogEditName: false,
            tmpNameStore: '',
            tmpSlugStore: '',
            tmpIdStore: '',
            typeEdit: 'old',
            tmpIndexNew: ''
        }
    },
    props: ['dataStore'],
    created() {
        var tmpStore = JSON.parse(this.dataStore)
        // console.log(tmpStore);
        this.data.id = tmpStore.id
        this.data.name = tmpStore.users[0].name
        this.data.email = tmpStore.users[0].email
        this.data.tmpPhone = tmpStore.users[0].code + tmpStore.users[0].phone
        this.data.address = tmpStore.users[0].address
        this.data.nameStore = tmpStore.name_store
        this.title = tmpStore.name_store
        this.data.slug = tmpStore.slug
        this.data.typeStoreId = tmpStore.type_store_id
        this.data.state = (tmpStore.state)?true:false
        this.data.pointSale = tmpStore.point_sale
        this.data.preventist = tmpStore.preventist
        this.data.sizePrint = tmpStore.size_print
        this.data.country = tmpStore.country
        this.data.inventory = (tmpStore.inventory)?true:false
        this.data.physicalStore = (tmpStore.physical_store)?true:false
        this.data.investmentMounths = tmpStore.investment_mounths
        this.data.investmentAmount = tmpStore.investment_amount
        this.data.profitabilityIn = tmpStore.profitability_in
        this.data.investmentInit = tmpStore.investment_init.split(' ')[0]
        this.data.preventistChange = (tmpStore.change_price_preventist)?true:false
        this.data.fidelityPoints = (tmpStore.fidelity_points)?true:false
        this.data.isDomain = (tmpStore.is_domain)?true:false
        this.data.restaurant = (tmpStore.restaurant)?true:false
        this.data.branches = tmpStore?.users[0].stores
        // this.data.password = this.genRandom()
    },
    mounted() {
        this.getTypeStores()
    },
    methods: {
        onInput(formattedNumber, { number, valid, country }) {
            this.data.phoneCode = '+'+country.dialCode
            this.data.phone = number.significant
            this.data.tmpPhone = number.international
            this.data.phoneIso = country.iso2
            this.data.phoneValid = valid

            this.data.country = country.iso2.toLowerCase()
        },
        /**
         * type stores
         */
         async getTypeStores() {
            await axios.get('/admin/list-types-stores')
            .then(response => {
                // console.log(response);
                this.itemsTypeStores = response.data
            })
            .catch(error => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        /**
         * register
         */
        genRandom () {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < 10; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result
            // this.data.password = result
        },
        async generateSlug(e, from='main') {
            var tmpSlug = (e.target.value).replace(/\s+/g, '-').toLowerCase()
            await axios.post('/admin/verify-slug', {tmpslug: tmpSlug})
            .then((response) => {
                // console.log(response)
                if (from == 'main') {
                    this.data.slug = response.data
                } else {
                    this.tmpSlugStore = response.data
                }
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async formEdit() {
            if (this.$refs.refedit.validate()) {
                if (!this.data.phoneValid) {
                    this.$alert('', 'Número de celular incorrecto.', 'error', {confirmButtonText: 'Continuar'})
                    return
                }
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('name', this.data.name)
                formData.append('email', this.data.email)
                formData.append('phone', this.data.phone)
                formData.append('code', this.data.phoneCode)
                formData.append('iso2', this.data.phoneIso)
                formData.append('address', this.data.address)
                formData.append('password', this.data.password)
                formData.append('name_store', this.data.nameStore)
                formData.append('slug', this.data.slug)
                formData.append('type_store_id', this.data.typeStoreId)
                formData.append('state', (this.data.state)?1:0)
                formData.append('point_sale', this.data.pointSale)
                formData.append('size_print', this.data.sizePrint)
                formData.append('preventist', this.data.preventist)
                formData.append('country', this.data.country)
                formData.append('inventory', (this.data.inventory)?1:0)
                formData.append('physical_store', (this.data.physicalStore)?1:0)
                formData.append('investment_mounths', this.data.investmentMounths)
                formData.append('investment_amount', this.data.investmentAmount)
                formData.append('profitability_in', this.data.profitabilityIn)
                formData.append('investment_init', this.data.investmentInit)
                formData.append('change_price_preventist', (this.data.preventistChange)?1:0)
                formData.append('fidelity_points', this.data.fidelityPoints?1:0)
                formData.append('is_domain', this.data.isDomain?1:0)
                formData.append('restaurant', (this.data.restaurant)?1:0)
                formData.append('new_branches', JSON.stringify(this.newBranches))

                formData.append('_method', 'PUT')

                await axios.post(`/admin/edit-store/${this.data.id}`, formData)
                .then((response) => {
                    // console.log(response);

                    if (response.data.msg == 'ok') {
                        this.$alert('', 'Datos actualizados con éxito.', 'success', {confirmButtonText: 'Continuar'});
                    }
                    if (response.data.pwd == 'success') {
                        this.data.password = ''
                        this.$notify.success('Contraseña actualizada con éxito.');
                    }
                    this.loading = false
                })
                .catch((error) => {
                    // console.log(error);
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            }
        },
        /**
         * delete
         */
        deleteStore(id) {
            this.$confirm(
                'Se eliminará permanentemente del sistema, si no esta seguro de esto puede cambiar de estado a inactivo.',
                '¿Eliminar negocio?',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/del-store/${id}`)
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', 'Negocio eliminado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                            location.reload()
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                    })
                }
            });
        },
        /**
         * cambio de estados
         */
        changeStateBranch(event, id) {
            this.$confirm(
                'Cambiar el estado del negocio, si no esta seguro de esto presione cancelar.',
                'Cambiar estado',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
            }).then(res => {
                if (res) {
                    axios.post(`/admin/state-store/${id}`, {state: event})
                    .then(response => {
                        // console.log(response);
                        if (response.data == 'ok') {
                            this.$alert('', 'Cambio de estado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                        }
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                    })
                }
            });
        },
        /**
         * cambio de nombre
         */
        async updateNameStore() {
            await axios.post(`/admin/update-name-store/${this.tmpIdStore}`, {name: this.tmpNameStore, slug: this.tmpSlugStore})
            .then(response => {
                // console.log(response);
                if (response.data == 'ok') {
                    this.$alert('', 'Negocio actualizado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                    location.reload()
                }
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        updateNewNameStore() {
            // this.data.name = this.tmpNameStore
            // this.data.slug = this.tmpSlugStore
            this.newBranches[this.tmpIndexNew].name_store = this.tmpNameStore
            this.newBranches[this.tmpIndexNew].slug = this.tmpSlugStore
            this.dialogEditName = false
        },
    },
}
</script>
